import { TDeviceType } from '@cian/ui-kit';

/**
 * Возвращает данные аналитики для поля `page`.
 *
 * Используются данные, аналогичные мкс-у `countryside-builder-card-frontend`,
 * чтобы они попадали в тот же аналитический отчет.
 * Это вынужденная мера, т.к. на момент написания не было аналитика,
 * который бы сделал нам отдельный дашборд.
 * В будущем, возможно, будет переделываться.
 */
export const getAnalyticsPageCard = (deviceType: TDeviceType) => {
  return {
    pageType: 'CardCountryBuilder',
    siteType: deviceType === 'phone' ? 'mobile' : deviceType,
  };
};
